import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { logSafeErrorWithoutCustomerData } from '@atlassian/jira-common-directory-v2/src/utils/log-safe-error';
import { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { COMPONENTS_ERROR_ANALYTICS } from '../../common/constant';
import { create } from '../services/create';
import {
	SAVE,
	CANCEL,
	SUCCESS,
	FAILURE,
	success,
	failure,
	validationFailure,
	type Action,
	type SuccessAction,
} from '../state/actions';
import {
	getProjectId,
	getProjectKey,
	getComponent,
	getOnClose,
	getOnComplete,
	getOnError,
} from '../state/selectors';
import type { State } from '../state/types';

const LOG_LOCATION = 'project-components.state.epics.create';

const epicOf =
	(
		type: 'state.CANCEL' | 'state.FAILURE' | 'state.SAVE' | 'state.SUCCESS',
		handler: (action: Action, state: State) => Observable<Action>,
	) =>
	(action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
		action$.ofType(type).mergeMap((action) => handler(action, store.getState()));

export const onClose = epicOf(CANCEL, (action, state) => {
	getOnClose(state)();
	return Observable.empty<never>();
});

// @ts-expect-error `ofType` does not refine the action type
export const onComplete = epicOf(SUCCESS, ({ payload }: SuccessAction, state) => {
	getOnComplete(state)(payload);
	return Observable.empty<never>();
});

export const onError = epicOf(FAILURE, (action, state) => {
	getOnError(state)();
	return Observable.empty<never>();
});

export const onSave = epicOf(SAVE, (action, state) => {
	const projectId = getProjectId(state);
	const projectKey = getProjectKey(state);
	const component = getComponent(state);

	return (
		Observable.fromPromise(create(projectId, projectKey, component))
			.mergeMap((createdComponent) => Observable.of(success(createdComponent)))
			// @ts-expect-error - TS2345 - Argument of type '(error: any) => Observable<ValidationFailureAction> | Observable<FailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<SuccessAction>) => ObservableInput<ValidationFailureAction>'.
			.catch((error) => {
				logSafeErrorWithoutCustomerData(error, LOG_LOCATION, COMPONENTS_ERROR_ANALYTICS);
				if (error instanceof ValidationError) {
					return Observable.of(validationFailure(error.errors));
				}
				return Observable.of(failure());
			})
	);
});
